// extracted by mini-css-extract-plugin
export default {"featureSection":"ExpressionOfInterestFeaturesSection_featureSection__6Cmkp","heading":"ExpressionOfInterestFeaturesSection_heading__t+90n"};